import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static outlets = ["map"]
  static targets = ["lat", "lng"]

  setMapCenter() {
    const center = this.mapOutlet.mapCenter
    this.latTarget.value = center.lat()
    // Normalize longitude to -180/180 range - Google Maps can return values
    // outside this range when panning past the antimeridian
    this.lngTarget.value = ((center.lng() % 360) + 540) % 360 - 180
  }
}